export default function initFooter() {
    const sfootEl = document.getElementById('sfoot');
    sfootEl && doInitFooter(sfootEl);
}


/**
 * @param {HTMLElement} sfootEl
 */
function doInitFooter(sfootEl) {

}
